
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const LeftArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14 8-4 4 4 4"/></svg>
  </SvgIcon>
);
